import { createReducer } from 'utils/reduxUtils';
import set from 'lodash/fp/set';
import get from 'lodash/fp/get';
import update from 'lodash/fp/update';
import reject from 'lodash/fp/reject';
import flow from 'lodash/fp/flow';
import {
  ACCOUNT_CARDS_DELETE_SUCCESS,
  ACCOUNT_CARDS_FETCH_FAIL,
  ACCOUNT_CARDS_FETCH_START,
  ACCOUNT_CARDS_FETCH_SUCCESS,
  ACCOUNT_CARDS_MAKE_DEFAULT_SUCCESS,
} from './actionTypes';
import initialState from './initialState';

const reducerToActionTypeMap = {
  [ACCOUNT_CARDS_FETCH_START]: set('isLoading', true),
  [ACCOUNT_CARDS_FETCH_SUCCESS]: (state, { payload } = {}) =>
    flow(
      set('isLoading', false),
      set('preferredCard', get('default_source', payload)),
      set('cards', get('sources.data', payload))
    )(state),
  [ACCOUNT_CARDS_FETCH_FAIL]: set('isLoading', false),
  [ACCOUNT_CARDS_MAKE_DEFAULT_SUCCESS]: (state, { payload } = {}) =>
    get('default', payload) // If default is set to true by back-end
      ? set('preferredCard', get('card.id', payload))(state) // Update default card in state
      : state, // else noop
  [ACCOUNT_CARDS_DELETE_SUCCESS]: (state, { payload } = {}) =>
    get('deleted', payload) // If deleted is set to true by back-end
      ? update('cards', reject({ id: payload.id }))(state) // Update cards by rejecting id matching payload id
      : state, // else noop
};

export default createReducer(reducerToActionTypeMap, initialState);
